module.exports = __webpack_public_path__ + "img/collected.667fc434.svg";